// Firestore Security Rules Guide for Nike 3D Application

export const recommendedFirestoreRules = `
rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    // Users can read and write their own user document
    match /users/{userId} {
      allow read, write: if request.auth != null && request.auth.uid == userId;
    }
    
    // Allow authenticated users to read all users (for admin purposes)
    // Remove this rule in production if you don't want users to see other users
    match /users/{userId} {
      allow read: if request.auth != null;
    }
    
    // Test collection - allow read/write for authenticated users
    match /test/{document} {
      allow read, write: if request.auth != null;
    }
    
    // Orders collection - users can only access their own orders
    match /orders/{orderId} {
      allow read, write: if request.auth != null && 
        request.auth.uid == resource.data.userId;
    }
    
    // Cart items - users can only access their own cart
    match /carts/{userId} {
      allow read, write: if request.auth != null && request.auth.uid == userId;
    }
    
    // Products collection - read-only for all authenticated users
    match /products/{productId} {
      allow read: if request.auth != null;
      allow write: if false; // Only admins should write products (implement admin logic)
    }
  }
}
`;

export const developmentFirestoreRules = `
rules_version = '2';
service cloud.firestore {
  match /databases/{database}/documents {
    // WARNING: These rules are for DEVELOPMENT ONLY
    // DO NOT use in production - they allow unrestricted access
    
    match /{document=**} {
      allow read, write: if true;
    }
  }
}
`;

export const firestoreRulesInstructions = `
🔐 Firestore Security Rules Setup Instructions:

1. Go to Firebase Console: https://console.firebase.google.com
2. Select your project: nike-92728
3. Navigate to: Firestore Database → Rules
4. Replace the existing rules with one of the rule sets below

📋 For Development (Testing):
   - Use the 'developmentFirestoreRules' (allows all operations)
   - This is ONLY for testing - never use in production

🛡️ For Production (Secure):
   - Use the 'recommendedFirestoreRules' (secure, user-specific access)
   - Users can only access their own data
   - Authenticated users required for all operations

🚨 Current Issue:
   If you're seeing permission errors, your rules might be too restrictive.
   Try the development rules first to test the connection, then switch to
   production rules once everything is working.

📝 How to Update Rules:
   1. Copy the rules from this guide
   2. Paste into Firebase Console → Firestore → Rules
   3. Click "Publish" to activate the new rules
   4. Test your application

⚡ Quick Fix for Testing:
   If you just want to test the connection quickly, use these simple rules:
   
   rules_version = '2';
   service cloud.firestore {
     match /databases/{database}/documents {
       match /{document=**} {
         allow read, write: if true;
       }
     }
   }
`;

export const logFirestoreRulesGuide = () => {
  console.log('🔐 Firestore Security Rules Guide');
  console.log('================================');
  console.log(firestoreRulesInstructions);
  console.log('');
  console.log('📋 DEVELOPMENT RULES (for testing):');
  console.log(developmentFirestoreRules);
  console.log('');
  console.log('🛡️ PRODUCTION RULES (secure):');
  console.log(recommendedFirestoreRules);
};
